export enum EnvironmentEnum {
  localdev = 'localdev',
  integration = 'integration',
  quality = 'quality',
  staging = 'staging',
  production = 'production',
}
